import React from "react";
import { Redirect, Switch } from "react-router";
import { getPath } from "common/routing";
import AppSelector from "./AppSelector";
import AdminLoginPage from "./Authentication/AdminLoginPage";
import UserLandingPage from "./Authentication/IdentifyUser/UserLandingPage";
import UserPasswordReset from "./Authentication/PasswordReset/UserPasswordReset";
import { AuthContextProvider } from "./Authorization/AuthContext";
import { UnauthedRoute } from "./Authorization/UnAuthedRoute";
import { MainRouteProps } from "./types";

export const RootDomainRoutes = (props: MainRouteProps) => {
  //only admins can be logged in on the root domain
  const landingPage = props.admin ? getPath("adminAccounts") : getPath("login");

  return (
    <Switch>
      <Redirect exact from="/" to={landingPage} />
      <UnauthedRoute
        {...props}
        path={getPath("login")}
        routeName="login"
        component={UserLandingPage}
      />
      <UnauthedRoute
        {...props}
        path={getPath("adminLogin")}
        routeName="adminLogin"
        component={AdminLoginPage}
      />
      <UnauthedRoute
        {...props}
        path={getPath("passwordResetRequest")}
        routeName="passwordResetRequest"
        component={UserPasswordReset}
      />
      <AuthContextProvider {...props}>
        <AppSelector />
      </AuthContextProvider>
    </Switch>
  );
};
